import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { DataTestRunnerStore } from './data-test-runner.store';
import { DataTestRunnerState } from './data-test.model';

@Injectable()
export class DataTestRunnerQuery extends Query<DataTestRunnerState> {
  constructor(protected store: DataTestRunnerStore) {
    super(store);
  }
}
